<template>
  <v-card
    class="mx-auto mt-2"
    max-width="400">
    <v-card-title>Logged in as: {{ CURRENT_USER_DISPLAY_NAME }}</v-card-title>

    <v-card-subtitle class="pb-0 pt-4">
      Logged in user roles
    </v-card-subtitle>
    <v-card-text class="text--primary">
      <div class="pl-1" v-for="item in USER_ROLES" :key="item">{{ item }}</div>
    </v-card-text>

    <v-card-subtitle class="pb-0 pt-4">
      Logged in user email
    </v-card-subtitle>
    <v-card-text class="text--primary">
      <div class="pl-1" >{{ CURRENT_USER_EMAIL }}</div>
    </v-card-text>

    <v-card-subtitle class="pb-0 pt-4">
      Logged in user first name, last name
    </v-card-subtitle>
    <v-card-text class="text--primary">
      <div class="pl-1" >{{ CURRENT_USER_FIRST_NAME }} {{ CURRENT_USER_LAST_NAME }}</div>
    </v-card-text>

    <v-card-subtitle class="pb-0 pt-4">
      Logged in user Identity Provider
    </v-card-subtitle>
    <v-card-text class="text--primary">
      <div class="pl-1" >{{ CURRENT_USER_IDP }}</div>
    </v-card-text>

  </v-card>

</template>

<script>
import { mapGetters } from 'vuex';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'UserDetails',
  components: {
  },
  computed: {
    ...mapGetters([
      storeConstants.CURRENT_USER_DISPLAY_NAME,
      storeConstants.CURRENT_USER_EMAIL,
      storeConstants.CURRENT_USER_FIRST_NAME,
      storeConstants.CURRENT_USER_LAST_NAME,
      storeConstants.CURRENT_USER_IDP,
      storeConstants.USER_ROLES,
    ]),
  },
};
</script>
